import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllProductFields } from '../../../actionCreators/hardwareproduct';

const useAllHardwareProduct = (
  parameters?: {},
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['hardwareProduct', parameters],
    queryFn: getAllProductFields,
    ...options,
  });
};

export default useAllHardwareProduct;
